import React from "react";
import "./Navbar.css";
import { Link } from "react-scroll";
import Logo from "../../img/logo.png"; 

const navbar = () => {
  return (
    <div className="n-wrapper" id="Navbar">
      {/* left */}
      <div className="n-left">
        <div className="logo">
        <img src={Logo} alt="Logo" className="logo-image" />

        </div>
      </div>
      {/* right */}
      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: "none" }}>
         

            <li>
              <Link to="labo" spy={true} smooth={true}>
              
              <h2 style={{fontWeight:"bold"}}>Infrastructure et équipements </h2> 

              </Link>
            </li>

            <li>
              <Link to="testimonial" spy={true} smooth={true}>
              
              <h2 style={{fontWeight:"bold"}}>Equipe de recherche</h2> 


              </Link>
            </li>

            <li>
              <Link to="portfolio" spy={true} smooth={true}>
              
              <h2 style={{fontWeight:"bold"}}>Conventions et collaborations externes</h2> 



              </Link>
            </li>

            <li>
              <Link to="services" spy={true} smooth={true}>
              
              <h2 style={{fontWeight:"bold"}}>Productivité Scientifique</h2> 




              </Link>
            </li>


          </ul>
        </div>
        <Link to="contact" spy={true} smooth={true}>
        <button style={{padding:"0.5rem 1rem"}} className="button n-button">Contact</button>
        </Link>
      </div>
    </div>
  );
};

export default navbar;
